import React from "react";
import { Outlet } from "react-router-dom";
import { Box, Container, Typography } from "@mui/material";
import { envConfig } from "utils/envConfig";
import { orange10 } from "theme/base";
import { withTheme } from "components/Theme";
import NavigationBar from "./NavigationBar";

export function Layout() {
  return withTheme((theme) => (
    <>
      {!envConfig.IsProdEnvironment && (
        <Box sx={{ backgroundColor: theme.alert, textAlign: "center" }}>
          <Typography variant="subtitle2" sx={{ color: orange10 }}>
            {envConfig.Environment}
          </Typography>
        </Box>
      )}
      <NavigationBar />
      <Outlet />
    </>
  ));
}

/**
 * The padding most routes want around their whole page. Mounted as a route wrapper rather than
 * baked into `Layout` itself, so a page with its own full-bleed header (`PageHeaderBar`) can sit
 * directly under `Layout` instead and keep its header edge-to-edge.
 */
export function PaddedRouteArea() {
  return (
    <Container maxWidth={false} sx={{ pt: 3 }}>
      <Outlet />
    </Container>
  );
}
